// // // // // // // // // Latest Version with Ajax Cart Version latest // // // // // // // // //

(function () {
  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  function $all(sel, root) {
    return Array.from((root || document).querySelectorAll(sel));
  }

  function safeJsonParse(text) {
    try {
      return JSON.parse(text);
    } catch (e) {
      return null;
    }
  }

  function normalize(s) {
    return (s || "").toString().trim().toLowerCase();
  }

  function getProduct() {
    var el = document.getElementById("LandingProductJSON");
    if (!el) return null;
    return safeJsonParse(el.textContent || "");
  }

  // Normalize all keys to lowercase for safe lookups
  var VARIANT_MAP = {
    terrazzo: { 1: 47472156541221, 3: 54834895683964, 9: 54961101144444 },
    anthracite: { 1: 47472156442917, 3: 49390479081765, 9: 54834895683964 },
    sagegrey: { 1: 54960949821820, 3: 54960949657980, 9: 54961101144444 },

  };

  
  function formatEURFromCents(cents) {
    if (typeof cents !== "number") return "";
    var s = new Intl.NumberFormat("de-DE", {
      style: "currency",
      currency: "EUR",
    }).format(cents / 100);

    return s.replace(/\s?€/g, "€");
  }

  function computeSavings(priceCents, compareCents) {
    if (!(compareCents > priceCents)) return null;

    var diff = compareCents - priceCents;
    var pct = Math.round((diff / compareCents) * 100);

    return {
      diffCents: diff,
      pct: pct,
    };
  }


  // Static landing-page prices by color + set selector.
  // Anthracite uses special landing-page prices; all other colors keep the normal static selector prices.
  var STATIC_SET_PRICES = {
    default: {
      1: { price: 2699, compare_at_price: 3999 },
      3: { price: 7499, compare_at_price: 11999 },
    },
    anthracite: {
      1: { price: 2499, compare_at_price: 3999 },
      3: { price: 6999, compare_at_price: 11999 },
    },
  };

  function getStaticSetPricing(colorKey, setCount) {
    var key = normalize(colorKey);
    var colorPrices = STATIC_SET_PRICES[key] || STATIC_SET_PRICES.default;
    var entry = colorPrices[setCount] || STATIC_SET_PRICES.default[setCount];

    if (!entry) {
      return {
        priceCents: null,
        compareCents: null,
        priceText: "",
        compareText: "",
        discountText: "",
      };
    }

    var savings = computeSavings(entry.price, entry.compare_at_price || 0);

    return {
      priceCents: entry.price,
      compareCents: entry.compare_at_price || null,
      priceText: formatEURFromCents(entry.price),
      compareText: entry.compare_at_price ? formatEURFromCents(entry.compare_at_price) : "",
      discountText: savings ? "-" + savings.pct + "%" : "",
    };
  }

  function getVariantById(product, id) {
    if (!product || !product.variants) return null;

    return (
      product.variants.find(function (v) {
        return Number(v.id) === Number(id);
      }) || null
    );
  }

  function getOfferRoot() {
    return document.getElementById("angebot") || document;
  }

  var LANDING_CART_NAMESPACE = "bemaxx-landing";
  var LANDING_GIFT_VARIANT_ID = 47472157884709;

  function escapeHtml(str) {
    return String(str || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function buildBundleGroupId() {
    return (
      "bemaxx-" + Date.now() + "-" + Math.random().toString(36).slice(2, 8)
    );
  }

  function getLandingCartEls() {
    return {
      trigger: document.querySelector("[data-landing-cart-open]"),
      count: document.querySelector("[data-landing-cart-count]"),
      drawer: document.querySelector("[data-landing-cart-drawer]"),
      loading: document.querySelector("[data-landing-cart-loading]"),
      empty: document.querySelector("[data-landing-cart-empty]"),
      content: document.querySelector("[data-landing-cart-content]"),
      items: document.querySelector("[data-landing-cart-items]"),
      subtotal: document.querySelector("[data-landing-cart-subtotal]"),
      checkout: document.querySelector("[data-landing-cart-checkout]"),
    };
  }

  function getLandingCartItems(cart) {
    return (cart.items || []).filter(function (item) {
      return (
        item.properties &&
        item.properties._landing_page === LANDING_CART_NAMESPACE
      );
    });
  }

  function groupLandingCartItems(items) {
    var groups = {};
    items.forEach(function (item) {
      var props = item.properties || {};
      var groupId = props._bundle_group || "ungrouped-" + item.key;

      if (!groups[groupId]) {
        groups[groupId] = {
          groupId: groupId,
          main: null,
          mains: [],
          mainQty: 0,
          mainFinalLinePrice: 0,
          gift: null,
          gifts: [],
          giftQty: 0,
          giftOriginalLinePrice: 0,
        };
      }

      var group = groups[groupId];
      var role = props._line_role;

      if (role === "main") {
        group.mains.push(item);
        if (!group.main) group.main = item;
        group.mainQty += Number(item.quantity || 0);
        group.mainFinalLinePrice += Number(item.final_line_price || 0);
      } else if (role === "gift") {
        group.gifts.push(item);
        if (!group.gift) group.gift = item;
        group.giftQty += Number(item.quantity || 0);
        group.giftOriginalLinePrice +=
          typeof item.original_line_price === "number"
            ? item.original_line_price
            : typeof item.original_price === "number"
              ? item.original_price * Number(item.quantity || 0)
              : 0;
      }
    });

    return Object.keys(groups).map(function (key) {
      return groups[key];
    });
  }

  function findLandingGroupById(cart, groupId) {
    return (
      groupLandingCartItems(getLandingCartItems(cart)).find(function (entry) {
        return entry.groupId === groupId;
      }) || null
    );
  }

  function setLandingCartBadge(items) {
    var els = getLandingCartEls();
    if (!els.count) return;
    var count = (items || []).reduce(function (sum, item) {
      return (
        sum +
        ((item.properties || {})._line_role === "main" ? item.quantity : 0)
      );
    }, 0);
    els.count.textContent = String(count);
    els.count.classList.toggle("hidden", count < 1);
  }

  function openLandingCartDrawer() {
    var els = getLandingCartEls();
    if (!els.drawer) return;
    els.drawer.hidden = false;
    requestAnimationFrame(function () {
      els.drawer.classList.add("is-open");
    });
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
  }

  function closeLandingCartDrawer() {
    var els = getLandingCartEls();
    if (!els.drawer) return;
    els.drawer.classList.remove("is-open");
    setTimeout(function () {
      if (els.drawer && !els.drawer.classList.contains("is-open"))
        els.drawer.hidden = true;
    }, 250);
    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";
  }

  function setLandingCartLoading(isLoading) {
    var els = getLandingCartEls();
    if (els.loading) els.loading.classList.toggle("hidden", !isLoading);
  }

  async function fetchCartJson() {
    var res = await fetch("/cart.js?ts=" + Date.now(), {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Cache-Control": "no-cache, no-store, must-revalidate",
        Pragma: "no-cache",
        Expires: "0",
      },
      credentials: "same-origin",
      cache: "no-store",
    });

    if (!res.ok) throw new Error("Cart fetch failed");
    return await res.json();
  }

  async function postCartJson(url, payload) {
    var res = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "same-origin",
      body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error("Cart request failed");
    return await res.json();
  }

  //
  async function updateCartLineQuantities(updates) {
    return await postCartJson("/cart/update.js", {
      updates: updates,
    });
  }

  function buildGroupedUpdates(items, desiredQty) {
    var updates = {};
    var remaining = Math.max(0, Number(desiredQty || 0));

    (items || []).forEach(function (item, index) {
      if (!item || !item.key) return;
      var nextQty = index === 0 ? remaining : 0;
      updates[item.key] = nextQty;
      if (index === 0) remaining = 0;
    });

    return updates;
  }

  async function syncGroupedItemsToQuantity(items, desiredQty) {
    var updates = buildGroupedUpdates(items, desiredQty);
    if (!Object.keys(updates).length) return null;
    return await updateCartLineQuantities(updates);
  }

  function buildGiftPropertiesFromMain(mainItem, groupId, giftPerMain) {
    var props = (mainItem && mainItem.properties) || {};
    return {
      _landing_page: LANDING_CART_NAMESPACE,
      _bundle_group: groupId,
      _line_role: "gift",
      _gift_per_main: String(giftPerMain),
      _selected_color: props._selected_color || "",
      _selected_set: props._selected_set || "",
      _selected_image: props._selected_image || "",
      _gift_locked: "true",
    };
  }

  //

  function buildMainProperties(
    bundleGroup,
    giftPerMain,
    colorLabel,
    selectedSet,
    selectedImage,
  ) {
    return {
      _landing_page: LANDING_CART_NAMESPACE,
      _bundle_group: bundleGroup,
      _line_role: "main",
      _gift_per_main: String(giftPerMain),
      _selected_color: colorLabel || "",
      _selected_set: selectedSet || "",
      _selected_image: selectedImage || "",
    };
  }

  function buildBundleAddItems(variantId, mainQty, mainProperties) {
    var parsedMainQty = Math.max(0, Number(mainQty || 0));
    var groupId =
      (mainProperties && mainProperties._bundle_group) || buildBundleGroupId();
    var giftPerMain = parseInt(
      (mainProperties && mainProperties._gift_per_main) || "1",
      10,
    );

    if (!variantId || parsedMainQty < 1) return [];

    return [
      {
        id: Number(variantId),
        quantity: parsedMainQty,
        properties: {
          _landing_page: LANDING_CART_NAMESPACE,
          _bundle_group: groupId,
          _line_role: "main",
          _gift_per_main: String(giftPerMain),
          _selected_color:
            (mainProperties && mainProperties._selected_color) || "",
          _selected_set: (mainProperties && mainProperties._selected_set) || "",
          _selected_image:
            (mainProperties && mainProperties._selected_image) || "",
        },
      },
      {
        id: LANDING_GIFT_VARIANT_ID,
        quantity: parsedMainQty * giftPerMain,
        properties: buildGiftPropertiesFromMain(
          { properties: mainProperties || {} },
          groupId,
          giftPerMain,
        ),
      },
    ];
  }

  function getGroupMainVariantId(group) {
    if (!group || !group.main) return 0;
    return Number(group.main.id || group.main.variant_id || 0);
  }

  async function ensureGroupGiftQuantity(
    group,
    desiredGiftQty,
    groupId,
    giftPerMain,
    mainProperties,
  ) {
    var safeDesiredGiftQty = Math.max(0, Number(desiredGiftQty || 0));

    if (group && group.gifts && group.gifts.length) {
      if (Number(group.giftQty || 0) !== safeDesiredGiftQty) {
        await syncGroupedItemsToQuantity(group.gifts, safeDesiredGiftQty);
      }
      return;
    }

    if (safeDesiredGiftQty > 0) {
      await postCartJson("/cart/add.js", {
        items: [
          {
            id: LANDING_GIFT_VARIANT_ID,
            quantity: safeDesiredGiftQty,
            properties: buildGiftPropertiesFromMain(
              { properties: mainProperties || {} },
              groupId,
              giftPerMain,
            ),
          },
        ],
      });
    }
  }

  //

  function renderLandingCart(cart) {
    var els = getLandingCartEls();
    if (!els.drawer) return;

    var landingItems = getLandingCartItems(cart);
    var groups = groupLandingCartItems(landingItems);
    setLandingCartBadge(landingItems);

    if (!groups.length) {
      if (els.empty) els.empty.classList.remove("hidden");
      if (els.content) els.content.classList.add("hidden");
      if (els.checkout) els.checkout.classList.add("hiddenn");
      if (els.items) els.items.innerHTML = "";
      if (els.subtotal) els.subtotal.textContent = formatEURFromCents(0);
      return;
    }

    if (els.empty) els.empty.classList.add("hidden");
    if (els.content) els.content.classList.remove("hidden");
    if (els.checkout) els.checkout.classList.remove("hiddenn");

    // Landing drawer subtotal intentionally excludes gift lines so gifts always appear free in this drawer.
    // Note: Shopify's actual cart/checkout total still depends on your discount configuration.
    var subtotal = groups.reduce(function (sum, group) {
      return sum + Number(group.mainFinalLinePrice || 0);
    }, 0);
    if (els.subtotal) els.subtotal.textContent = formatEURFromCents(subtotal);

    if (els.items) {
      els.items.innerHTML = groups
        .map(function (group) {
          var main = group.main;
          var gift = group.gift;
          if (!main) return "";

          var image =
            (main.properties && main.properties._selected_image) ||
            (main.featured_image && main.featured_image.url
              ? main.featured_image.url
              : main.image || "");
          var color = main.properties
            ? main.properties._selected_color || ""
            : "";
          var setText = main.properties
            ? main.properties._selected_set || ""
            : "";
          var mainQty = Number(group.mainQty || 0);
          var linePrice = formatEURFromCents(group.mainFinalLinePrice || 0);
          var giftQty = Number(group.giftQty || 0);
          var giftTitle = gift
            ? gift.product_title || gift.title || "Gratis Geschenk"
            : "";
          var giftImage =
            gift &&
            (gift.featured_image && gift.featured_image.url
              ? gift.featured_image.url
              : gift.image || "");
          var giftOriginalTotal =
            gift && Number(group.giftOriginalLinePrice || 0) > 0
              ? formatEURFromCents(group.giftOriginalLinePrice)
              : "";
          var giftPriceHtml = gift
            ? '<div class="bemaxx-cart-item__price">' +
              (giftOriginalTotal
                ? '<span class="line-through">' + giftOriginalTotal + "</span> "
                : "") +
              "<strong>Kostenlos!</strong>" +
              "</div>"
            : "";

          return (
            "" +
            '<div class="bemaxx-cart-item" data-group-id="' +
            escapeHtml(group.groupId) +
            '">' +
            '<div class="bemaxx-cart-item__row">' +
            (image
              ? '<img class="bemaxx-cart-item__img" src="' +
                escapeHtml(image) +
                '" alt="' +
                escapeHtml(main.product_title || main.title || "Produkt") +
                '">'
              : '<div class="bemaxx-cart-item__img bemaxx-cart-item__img--empty"></div>') +
            '<div class="bemaxx-cart-item__meta">' +
            '<div class="bemaxx-cart-item__title">' +
            escapeHtml(main.product_title || main.title || "Produkt") +
            "</div>" +
            (color
              ? '<div class="bemaxx-cart-item__sub">' +
                escapeHtml(color) +
                "</div>"
              : "") +
            (setText
              ? '<div class="bemaxx-cart-item__sub">' +
                escapeHtml(setText) +
                "</div>"
              : "") +
            '<div class="bemaxx-cart-item__controls">' +
            '<button type="button" class="bemaxx-cart-item__qty-btn" data-landing-cart-minus data-group-id="' +
            escapeHtml(group.groupId) +
            '" data-current-qty="' +
            mainQty +
            '">−</button>' +
            '<span class="bemaxx-cart-item__qty">' +
            "Mange: " +
            mainQty +
            "</span>" +
            '<button type="button" class="bemaxx-cart-item__qty-btn" data-landing-cart-plus data-group-id="' +
            escapeHtml(group.groupId) +
            '" data-current-qty="' +
            mainQty +
            '">+</button>' +
            '<button type="button" class="bemaxx-cart-item__remove" data-landing-cart-remove data-group-id="' +
            escapeHtml(group.groupId) +
            '">Entfernen</button>' +
            "</div>" +
            "</div>" +
            '<div class="bemaxx-cart-item__price">' +
            linePrice +
            "</div>" +
            "</div>" +
            (gift
              ? '<div class="bemaxx-cart-item__row bemaxx-cart-item__row--gift">' +
                (giftImage
                  ? '<img class="bemaxx-cart-item__img" src="' +
                    escapeHtml(giftImage) +
                    '" alt="' +
                    escapeHtml(giftTitle) +
                    '">'
                  : '<div class="bemaxx-cart-item__img bemaxx-cart-item__img--empty"></div>') +
                '<div class="bemaxx-cart-item__meta">' +
                '<div class="bemaxx-cart-item__title">' +
                escapeHtml(giftTitle) +
                "</div>" +
                '<div class="bemaxx-cart-item__sub">Gratis Geschenk</div>' +
                '<div class="bemaxx-cart-item__sub">Menge: ' +
                giftQty +
                "</div>" +
                "</div>" +
                giftPriceHtml +
                "</div>"
              : "") +
            "</div>"
          );
        })
        .join("");
    }
  }

  //

  async function refreshLandingCart(shouldOpen) {
    setLandingCartLoading(true);
    try {
      var cart = await fetchCartJson();
      renderLandingCart(cart);
      if (shouldOpen) openLandingCartDrawer();
    } finally {
      setLandingCartLoading(false);
    }
  }

  async function addLandingBundleToCart(root) {
    syncStateFromDom(root);
    var variantId = getSelectedVariantId();
    if (!variantId) {
      alert("Bitte wählen Sie eine Variante.");
      return;
    }

    // 1 free product with Set 1 and 3 with Set 3
    // var requestedQty = state.orderQty;
    // var giftPerMain = state.setCount === 3 ? 3 : 1;

    // 1 free product with each Set
    var requestedQty = state.orderQty;
    var giftPerMain = 1;

    var bundleGroup = buildBundleGroupId();
    var selectedSet =
      state.setCount + (state.setCount === 1 ? " Set" : " Sets");
    var variant = getVariantById(getProduct(), variantId);
    var selectedImage =
      (variant &&
        (variant.featured_image &&
        (variant.featured_image.src || variant.featured_image.url)
          ? variant.featured_image.src || variant.featured_image.url
          : variant.featured_media &&
              variant.featured_media.preview_image &&
              (variant.featured_media.preview_image.src ||
                variant.featured_media.preview_image.url)
            ? variant.featured_media.preview_image.src ||
              variant.featured_media.preview_image.url
            : variant.image || "")) ||
      "";

    var mainProperties = buildMainProperties(
      bundleGroup,
      giftPerMain,
      state.colorLabel,
      selectedSet,
      selectedImage,
    );

    setLandingCartLoading(true);
    try {
      var addErrored = false;

      try {
        await postCartJson("/cart/add.js", {
          items: buildBundleAddItems(variantId, requestedQty, mainProperties),
        });
      } catch (e) {
        addErrored = true;
        console.error(e);
      }

      var cart = await fetchCartJson();
      var group = findLandingGroupById(cart, bundleGroup);
      var actualAddedQty = group ? Number(group.mainQty || 0) : 0;

      if (!actualAddedQty) {
        await refreshLandingCart(false);
        alert("Produkte konnten nicht zum Warenkorb hinzugefügt werden.");
        return;
      }

      await ensureGroupGiftQuantity(
        group,
        actualAddedQty * giftPerMain,
        bundleGroup,
        giftPerMain,
        mainProperties,
      );

      await refreshLandingCart(true);

      if (addErrored || actualAddedQty < requestedQty) {
        alert(
          "Es konnten nur " +
            actualAddedQty +
            " von " +
            requestedQty +
            " Produkten hinzugefügt werden.",
        );
      }
    } catch (e) {
      console.error(e);
      try {
        await refreshLandingCart(false);
      } catch (_) {
        setLandingCartLoading(false);
      }
      alert("Produkte konnten nicht zum Warenkorb hinzugefügt werden.");
    }
  }

  //

  async function changeCartLineQuantity(lineKey, quantity) {
    return await postCartJson("/cart/change.js", {
      id: lineKey,
      quantity: quantity,
    });
  }

  async function syncLandingBundleQuantity(groupId, nextQty) {
    setLandingCartLoading(true);
    try {
      if (nextQty < 1) {
        await removeLandingBundle(groupId);
        return;
      }

      var cart = await fetchCartJson();
      var group = findLandingGroupById(cart, groupId);

      if (!group || !group.main || !group.mains || !group.mains.length) {
        await refreshLandingCart(false);
        return;
      }

      // 1 free product with 1 set, 3 with 3 set
      // var previousMainQty = Number(group.mainQty || 0);
      // var giftPerMain = parseInt(
      //   (group.main.properties && group.main.properties._gift_per_main) || "1",
      //   10,
      // );

      // 1 free product with 1 each set
      var previousMainQty = Number(group.mainQty || 0);
      var giftPerMain = 1;
      //

      var mainProperties = buildMainProperties(
        groupId,
        giftPerMain,
        (group.main.properties && group.main.properties._selected_color) || "",
        (group.main.properties && group.main.properties._selected_set) || "",
        (group.main.properties && group.main.properties._selected_image) || "",
      );

      var mainVariantId = getGroupMainVariantId(group);

      // INCREASE: add the delta as main + gift together in one cart/add.js request
      if (nextQty > previousMainQty) {
        var increaseBy = nextQty - previousMainQty;
        var addErrored = false;

        try {
          await postCartJson("/cart/add.js", {
            items: buildBundleAddItems(
              mainVariantId,
              increaseBy,
              mainProperties,
            ),
          });
        } catch (e) {
          addErrored = true;
          console.error(e);
        }

        cart = await fetchCartJson();
        var increasedGroup = findLandingGroupById(cart, groupId);
        var actualMainQtyAfterIncrease = increasedGroup
          ? Number(increasedGroup.mainQty || 0)
          : previousMainQty;

        await ensureGroupGiftQuantity(
          increasedGroup,
          actualMainQtyAfterIncrease * giftPerMain,
          groupId,
          giftPerMain,
          mainProperties,
        );

        await refreshLandingCart(false);

        if (addErrored || actualMainQtyAfterIncrease < nextQty) {
          alert("Es sind bereits alle verfügbaren Mengen im Warenkorb.");
        }

        return;
      }

      // DECREASE: reshape existing bundle lines downward
      await syncGroupedItemsToQuantity(group.mains, nextQty);

      var updatedGroup = null;
      for (var attempt = 0; attempt < 6; attempt++) {
        await new Promise(function (resolve) {
          setTimeout(resolve, 250);
        });

        cart = await fetchCartJson();
        updatedGroup = findLandingGroupById(cart, groupId);

        if (!updatedGroup || !updatedGroup.main) break;
        if (Number(updatedGroup.mainQty || 0) === nextQty) break;
      }

      if (!updatedGroup || !updatedGroup.main) {
        await refreshLandingCart(false);
        return;
      }

      await ensureGroupGiftQuantity(
        updatedGroup,
        nextQty * giftPerMain,
        groupId,
        giftPerMain,
        mainProperties,
      );

      await refreshLandingCart(false);
    } catch (e) {
      console.error(e);
      try {
        await refreshLandingCart(false);
      } catch (_) {
        setLandingCartLoading(false);
      }
      alert("Warenkorb konnte nicht aktualisiert werden.");
    }
  }

  async function removeLandingBundle(groupId) {
    setLandingCartLoading(true);
    try {
      var cart = await fetchCartJson();
      var group = findLandingGroupById(cart, groupId);
      if (!group) {
        await refreshLandingCart(false);
        return;
      }

      var updates = {};
      (group.gifts || []).forEach(function (item) {
        if (item && item.key) updates[item.key] = 0;
      });
      (group.mains || []).forEach(function (item) {
        if (item && item.key) updates[item.key] = 0;
      });

      if (Object.keys(updates).length) {
        await updateCartLineQuantities(updates);
      }

      cart = await fetchCartJson();
      group = findLandingGroupById(cart, groupId);

      await refreshLandingCart(false);

      if (group) {
        alert("Bundle konnte nicht entfernt werden.");
      }
    } catch (e) {
      console.error(e);
      try {
        await refreshLandingCart(false);
      } catch (_) {
        setLandingCartLoading(false);
      }
      alert("Bundle konnte nicht entfernt werden.");
    }
  }

  //

  function bindLandingCartDrawer() {
    var els = getLandingCartEls();
    if (!els.drawer || !els.trigger) return;

    els.trigger.addEventListener("click", function (e) {
      e.preventDefault();
      refreshLandingCart(true);
    });

    els.drawer.addEventListener("click", function (e) {
      if (e.target.closest("[data-landing-cart-close]")) {
        closeLandingCartDrawer();
        return;
      }

      if (e.target.closest("[data-landing-cart-shop-now]")) {
        closeLandingCartDrawer();
        scrollToId("angebot");
        return;
      }

      var plus = e.target.closest("[data-landing-cart-plus]");
      if (plus) {
        var currentPlus = parseInt(
          plus.getAttribute("data-current-qty") || "1",
          10,
        );
        syncLandingBundleQuantity(
          plus.getAttribute("data-group-id"),
          currentPlus + 1,
        );
        return;
      }

      var minus = e.target.closest("[data-landing-cart-minus]");
      if (minus) {
        var currentMinus = parseInt(
          minus.getAttribute("data-current-qty") || "1",
          10,
        );
        if (currentMinus <= 1) {
          removeLandingBundle(minus.getAttribute("data-group-id"));
        } else {
          syncLandingBundleQuantity(
            minus.getAttribute("data-group-id"),
            currentMinus - 1,
          );
        }
        return;
      }

      var removeBtn = e.target.closest("[data-landing-cart-remove]");
      if (removeBtn) {
        removeLandingBundle(removeBtn.getAttribute("data-group-id"));
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeLandingCartDrawer();
    });

    refreshLandingCart(false);
  }

  function getColorButtons(root) {
    return $all("button", root).filter(function (btn) {
      return !!btn.querySelector("[data-landing-color]");
    });
  }

  function getSetButtons(root) {
    return $all("button", root).filter(function (btn) {
      if (btn.querySelector("[data-landing-qty]")) return true;

      var text = (btn.textContent || "").trim();
      var hasSetLabel = /\b(1|3|9)\s+Set(s)?\b/i.test(text);
      var hasDetail = /Matten\s*\+\s*\d+\s*Randstücke/i.test(text);
      return hasSetLabel && hasDetail;
    });
  }

  function getBuyButton(root) {
    return (
      root.querySelector('button[data-landing-cta="buy"]') ||
      $all("button", root).find(function (b) {
        return (
          /Jetzt bestellen/i.test(b.textContent || "") &&
          (b.className || "").indexOf("animate-pulse-red") !== -1
        );
      }) ||
      null
    );
  }

  function getSummaryRoot(root) {
    return (
      root.querySelector("div.bg-slate-50.rounded-2xl.p-6.mb-8") ||
      root.querySelector("div.bg-slate-50.rounded-2xl") ||
      null
    );
  }

  var state = {
    colorKey: "Green",
    colorLabel: "Green",
    setCount: 1,
    orderQty: 1,
  };

  function syncStateFromDom(root) {
    var colorBtns = getColorButtons(root);
    var activeColorBtn =
      colorBtns.find(function (btn) {
        return (btn.className || "").indexOf("border-red-600") !== -1;
      }) || colorBtns[0];

    if (activeColorBtn) {
      var colorEl = activeColorBtn.querySelector("[data-landing-color]");
      var label =
        (colorEl &&
          (colorEl.getAttribute("data-landing-color") ||
            colorEl.textContent ||
            "")) ||
        "";
      state.colorLabel = label.trim() || "Terrazzo";
      state.colorKey = normalize(state.colorLabel);
    }

    var setBtns = getSetButtons(root);
    var activeSetBtn =
      setBtns.find(function (btn) {
        return (btn.className || "").indexOf("border-red-600") !== -1;
      }) || setBtns[0];

    if (activeSetBtn) {
      var qtyEl = activeSetBtn.querySelector("[data-landing-qty]");
      var qtySource = qtyEl
        ? qtyEl.getAttribute("data-landing-qty") || qtyEl.textContent || "1"
        : activeSetBtn.textContent || "1";
      var qtyMatch = String(qtySource).match(/\b(1|3|9)\b/);
      var qty = qtyMatch ? parseInt(qtyMatch[1], 10) : 1;
      state.setCount = qty === 3 ? 3 : qty === 9 ? 9 : 1;
    }
  }

  function updateOrderQtyUI(root) {
    var qtyValue = root.querySelector("[data-order-qty-value]");
    if (qtyValue) {
      qtyValue.textContent = String(state.orderQty);
    }
  }

  function bindOrderQty(root, product) {
    var minusBtn = root.querySelector("[data-order-qty-minus]");
    var plusBtn = root.querySelector("[data-order-qty-plus]");

    if (!minusBtn || !plusBtn) return;

    minusBtn.addEventListener("click", function () {
      if (state.orderQty > 1) {
        state.orderQty -= 1;
        updateOrderQtyUI(root);
        updateSummaryPanel(root, product);
      }
    });

    plusBtn.addEventListener("click", function () {
      state.orderQty += 1;
      updateOrderQtyUI(root);
      updateSummaryPanel(root, product);
    });
  }

  function setActive(buttons, activeButton) {
    buttons.forEach(function (btn) {
      btn.classList.remove("border-red-600");
      btn.classList.remove("bg-red-50");
      if (!btn.classList.contains("border-gray-200")) {
        btn.classList.add("border-gray-200");
      }

      // hide checkmark on all buttons
      var chk = btn.querySelector("[data-color-check]");
      if (chk) chk.classList.add("hidden");
    });

    if (!activeButton) return;

    activeButton.classList.add("border-red-600");
    activeButton.classList.add("bg-red-50");
    activeButton.classList.remove("border-gray-200");

    // show checkmark on active button
    var activeChk = activeButton.querySelector("[data-color-check]");
    if (activeChk) activeChk.classList.remove("hidden");
  }

  function getSelectedVariantId() {
    if (!VARIANT_MAP[state.colorKey]) return null;
    return VARIANT_MAP[state.colorKey][state.setCount] || null;
  }

  function getSelectedSetDetailText(root) {
    var setBtns = getSetButtons(root);
    var active =
      setBtns.find(function (btn) {
        return (btn.className || "").indexOf("border-red-600") !== -1;
      }) || setBtns[0];

    if (!active) return "";

    var detail = $all("p", active).find(function (p) {
      return /Matten\s*\+\s*\d+\s*Randstücke/i.test(p.textContent || "");
    });

    return detail ? (detail.textContent || "").trim() : "";
  }

  function parseEuroTextToCents(text) {
    if (!text) return null;
    var normalized = String(text)
      .replace(/\s/g, "")
      .replace(/€/g, "")
      .replace(/\./g, "")
      .replace(/,/g, ".");
    var value = parseFloat(normalized);
    return isNaN(value) ? null : Math.round(value * 100);
  }

  function getActiveSetButton(root) {
    var setBtns = getSetButtons(root);
    return (
      setBtns.find(function (btn) {
        return (btn.className || "").indexOf("border-red-600") !== -1;
      }) ||
      setBtns[0] ||
      null
    );
  }

  function getSelectedSetPricing(root, product) {
    return getStaticSetPricing(state.colorKey, state.setCount);
  }

  function getSelectedColorButton(root) {
    var colorBtns = getColorButtons(root);
    return (
      colorBtns.find(function (btn) {
        return (btn.className || "").indexOf("border-red-600") !== -1;
      }) ||
      colorBtns[0] ||
      null
    );
  }

  function updateSummarySwatch(summary, root) {
    var activeColorBtn = getSelectedColorButton(root);
    var sourceSwatch = activeColorBtn
      ? activeColorBtn.querySelector("div")
      : null;
    var targetSwatch = summary ? summary.querySelector("div.w-20.h-20") : null;

    if (!sourceSwatch || !targetSwatch) return;

    var nextClasses = ["w-20", "h-20", "rounded-xl", "shadow-lg"];

    Array.from(sourceSwatch.classList).forEach(function (cls) {
      if (/^w-\d+/.test(cls)) return;
      if (/^h-\d+/.test(cls)) return;
      if (cls === "rounded-full") return;
      if (cls === "rounded-xl") return;
      if (cls === "w-20" || cls === "h-20") return;
      nextClasses.push(cls);
    });

    targetSwatch.className = nextClasses.join(" ");
  }

  function updateCtaLabel(root) {
    var btn = getBuyButton(root);
    if (!btn) return;

    btn.textContent =
      "Jetzt bestellen – " +
      state.setCount +
      (state.setCount === 1 ? " Set" : " Sets") +
      " in " +
      state.colorLabel +
      " x " +
      state.orderQty;

    var variantId = getSelectedVariantId();
    if (variantId) btn.setAttribute("data-variant-id", String(variantId));
    btn.setAttribute("data-landing-cta", "buy");
  }

  function updateSummaryPanel(root, product) {
    var summary = getSummaryRoot(root);
    if (!summary) {
      updateCtaLabel(root);
      return;
    }

    var variantId = getSelectedVariantId();
    var variant = variantId ? getVariantById(product, variantId) : null;
    var ps = $all("p", summary);

    var titleEl =
      ps.find(function (p) {
        return /\b(1|3|9)\s+(Set|Sets)\b/i.test((p.textContent || "").trim());
      }) || null;

    if (titleEl) {
      var setLine = titleEl.querySelector("[data-summary-set]");
      if (setLine) {
        setLine.textContent =
          state.setCount + (state.setCount === 1 ? " Set" : " Sets");
      } else {
        titleEl.innerHTML =
          "bemaxx Bodenschutzmatten<br><span data-summary-set>" +
          state.setCount +
          (state.setCount === 1 ? " Set" : " Sets") +
          "</span>";
      }
    }

    var colorLabels = getColorButtons(root).map(function (btn) {
      var el = btn.querySelector("[data-landing-color]");
      return normalize(
        el ? el.getAttribute("data-landing-color") || el.textContent || "" : "",
      );
    });

    var colorEl =
      ps.find(function (p) {
        var t = normalize(p.textContent || "");
        return colorLabels.indexOf(t) !== -1;
      }) || null;

    if (colorEl) {
      colorEl.textContent = state.colorLabel;
    }

    var orderQtyEl = summary.querySelector("[data-summary-order-qty]");
    if (orderQtyEl) {
      orderQtyEl.textContent = String(state.orderQty);
    }

    var detailText = getSelectedSetDetailText(root);
    var detailEl =
      ps.find(function (p) {
        return /Matten\s*\+\s*\d+\s*Randstücke/i.test(p.textContent || "");
      }) || null;

    if (detailEl && detailText) {
      detailEl.textContent = detailText;
    }

    updateSummarySwatch(summary, root);

    var selectedPricing = getSelectedSetPricing(root, product);

    var totalPriceCents =
      selectedPricing.priceCents !== null
        ? selectedPricing.priceCents * state.orderQty
        : null;

    var totalCompareCents =
      selectedPricing.compareCents !== null
        ? selectedPricing.compareCents * state.orderQty
        : null;

    var summaryPriceEl =
      $all("p, span", summary).find(function (el) {
        return (
          (el.className || "").indexOf("text-red-600") !== -1 &&
          (el.textContent || "").indexOf("€") !== -1
        );
      }) || null;

    if (summaryPriceEl && totalPriceCents !== null) {
      summaryPriceEl.textContent = formatEURFromCents(totalPriceCents);
    }

    var summaryCompareEl = summary.querySelector("span.line-through");
    if (summaryCompareEl) {
      summaryCompareEl.textContent =
        totalCompareCents !== null ? formatEURFromCents(totalCompareCents) : "";
    }

    var savingsP =
      ps.find(function (p) {
        return (
          /Sie sparen/i.test(p.textContent || "") ||
          !!p.querySelector("span.line-through")
        );
      }) || null;

    if (savingsP) {
      var compareHtml =
        summaryCompareEl && totalCompareCents !== null
          ? summaryCompareEl.outerHTML
          : "";

      var discountText = (selectedPricing.discountText || "").replace(/^-/, "");

      if (
        totalCompareCents !== null &&
        totalPriceCents !== null &&
        totalCompareCents > totalPriceCents
      ) {
        var totalSavings = totalCompareCents - totalPriceCents;

        savingsP.innerHTML =
          compareHtml +
          " Sie sparen " +
          formatEURFromCents(totalSavings) +
          (discountText ? " (" + discountText + ")" : "");
      } else {
        savingsP.innerHTML = compareHtml;
      }
    }

    updateCtaLabel(root);
  }

  function updateSetCardsPrices(root, product) {
    getSetButtons(root).forEach(function (btn) {
      var qtyEl = btn.querySelector("[data-landing-qty]");
      var qtySource = qtyEl
        ? qtyEl.getAttribute("data-landing-qty") || qtyEl.textContent || "1"
        : btn.textContent || "1";
      var qtyMatch = String(qtySource).match(/\b(1|3|9)\b/);
      var setCount = qtyMatch ? parseInt(qtyMatch[1], 10) : 1;

      var pricing = getStaticSetPricing(state.colorKey, setCount);
      if (pricing.priceCents === null) return;

      var priceEl =
        $all("*", btn).find(function (el) {
          return (
            (el.className || "").indexOf("text-red-600") !== -1 &&
            (el.textContent || "").indexOf("€") !== -1
          );
        }) || null;

      if (priceEl) {
        priceEl.textContent = pricing.priceText;
      }

      var compareEl = btn.querySelector("span.line-through");
      if (compareEl) {
        compareEl.textContent =
          pricing.compareCents && pricing.compareCents > pricing.priceCents
            ? pricing.compareText
            : "";
      }

      var badgeEl =
        $all("span", btn).find(function (el) {
          return /^-\d+%$/.test((el.textContent || "").trim());
        }) || null;

      if (badgeEl) {
        badgeEl.textContent = pricing.discountText;
      }
    });
  }


  var FAQS = [
    {
      q: "Wie schnell werden die Matten geliefert?",
      a: "In der Regel innerhalb von 2-4 Werktagen. Bei Bestellungen vor 14 Uhr versenden wir noch am selben Tag.",
    },
    {
      q: "Sind die Matten wirklich ungiftig?",
      a: "Absolut! Sie sind nach EN 71-3 laborgeprüft, BPA-frei und eignen sich dadurch hervorragend für den Einsatz in den eigenen 4 Wänden. Das Prüfengel Institut hat sie mit der Note 1.3 (SEHR GUT) bewertet.",
    },
    {
      q: "Was ist, wenn ich nicht zufrieden bin?",
      a: "Kein Problem! Wir bieten eine 30-Tage-Geld-zurück-Garantie. Wenn Sie nicht 100% zufrieden sind, erhalten Sie Ihr Geld zurück – ohne Wenn und Aber.",
    },
    {
      q: "Wie viele Matten brauche ich?",
      a: "Unser Set enthält 18 Matten (32x32cm) plus 27 Randstücke – das ergibt ca. 1,7 m². Das reicht für eine kleine Spielecke. Für eine größere Fläche empfehlen wir 3-6 Sets und für ein ganzes Zimmer am besten die Fläche ausmessen und durch 1,7 m² rechnen.",
    },
    {
      q: "Wie reinige ich die Matten?",
      a: "Ganz einfach: Mit einem feuchten Tuch abwischen. Die wasserdichte Oberfläche verhindert, dass Flüssigkeiten eindringen.",
    },
  ];

  function initFaqAccordion() {
    var acc = document.querySelector('[data-slot="accordion"]');
    if (!acc) return;

    var items = $all('[data-slot="accordion-item"]', acc);
    if (!items.length) return;

    items.forEach(function (item) {
      var trigger = $('[data-slot="accordion-trigger"]', item);
      var content = $('[data-slot="accordion-content"]', item);

      if (!trigger || !content) return;

      if (!content.textContent || !content.textContent.trim()) {
        var question = (trigger.textContent || "").trim();
        var found = FAQS.find(function (f) {
          return f.q === question;
        });

        if (found) {
          content.textContent = found.a;
          if ((content.className || "").indexOf("pb-4") === -1) {
            content.className += " text-gray-600 pb-4";
          }
        }
      }

      function setOpen(isOpen) {
        item.setAttribute("data-state", isOpen ? "open" : "closed");
        trigger.setAttribute("aria-expanded", isOpen ? "true" : "false");
        trigger.setAttribute("data-state", isOpen ? "open" : "closed");
        content.hidden = !isOpen;
        content.setAttribute("data-state", isOpen ? "open" : "closed");
      }

      setOpen(false);

      trigger.addEventListener("click", function () {
        var isOpen = item.getAttribute("data-state") === "open";

        items.forEach(function (it) {
          if (it === item) return;
          var t = $('[data-slot="accordion-trigger"]', it);
          var c = $('[data-slot="accordion-content"]', it);

          if (!t || !c) return;

          it.setAttribute("data-state", "closed");
          t.setAttribute("aria-expanded", "false");
          t.setAttribute("data-state", "closed");
          c.hidden = true;
          c.setAttribute("data-state", "closed");
        });

        setOpen(!isOpen);
      });
    });
  }

  function scrollToId(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }

  function bindScrollCtas() {
    $all("button").forEach(function (btn) {
      if (
        (btn.textContent || "").trim() === "Jetzt bestellen" &&
        !btn.hasAttribute("data-landing-cta")
      ) {
        btn.setAttribute("data-landing-cta", "scroll");
      }
    });

    $all('[data-landing-cta="scroll"]').forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        scrollToId("angebot");
      });
    });

    var map = {
      vorteile: "vorteile",
      technologie: "technologie",
      bewertungen: "bewertungen",
      faq: "faq",
    };

    $all("header nav button, footer button").forEach(function (b) {
      b.addEventListener("click", function () {
        var key = normalize(b.textContent || "");
        if (map[key]) scrollToId(map[key]);
      });
    });
  }

  function bindOfferSelection(root, product) {
    var colorBtns = getColorButtons(root);
    var setBtns = getSetButtons(root);

    if (
      !colorBtns.some(function (btn) {
        return (btn.className || "").indexOf("border-red-600") !== -1;
      }) &&
      colorBtns[0]
    ) {
      setActive(colorBtns, colorBtns[0]);
    }

    if (
      !setBtns.some(function (btn) {
        return (btn.className || "").indexOf("border-red-600") !== -1;
      }) &&
      setBtns[0]
    ) {
      setActive(setBtns, setBtns[0]);
    }

    colorBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        setActive(colorBtns, btn);
        syncStateFromDom(root);
        updateSetCardsPrices(root, product);
        updateSummaryPanel(root, product);
      });
    });

    setBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        setActive(setBtns, btn);
        syncStateFromDom(root);
        updateSummaryPanel(root, product);
      });
    });
  }

  function bindBuyCta(root) {
    var btn = getBuyButton(root);
    if (!btn) return;

    btn.setAttribute("data-landing-cta", "buy");

    btn.addEventListener("click", function (e) {
      e.preventDefault();
      addLandingBundleToCart(root);
    });
  }

  function init() {
    var product = getProduct();

    bindScrollCtas();
    initFaqAccordion();

    if (!product) return;

    var root = getOfferRoot();

    syncStateFromDom(root);
    updateOrderQtyUI(root);
    updateSetCardsPrices(root, product);
    updateSummaryPanel(root, product);

    bindOfferSelection(root, product);
    bindOrderQty(root, product);
    bindBuyCta(root);
    bindLandingCartDrawer();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

// // // // // // // // // /// // // // // // Popup Models Code // // // // // // // // /// //

(function () {
  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function footerLinkMatches(link) {
    if (!link || link.tagName !== "A") return false;
    var label = (link.textContent || "").trim().toLowerCase();
    var allowed = [
      "kontakt",
      "versand",
      "rückgabe",
      "garantie",
      "impressum",
      "datenschutz",
      "agb",
      "widerruf",
    ];
    return (
      link.hasAttribute("data-footer-modal") || allowed.indexOf(label) !== -1
    );
  }

  function ensureStyles() {
    if (document.getElementById("bemaxx-footer-srcdoc-modal-styles")) return;
    var style = document.createElement("style");
    style.id = "bemaxx-footer-srcdoc-modal-styles";
    style.textContent =
      "" +
      "#bemaxx-footer-srcdoc-modal{position:fixed;inset:0;z-index:99999;display:none;}" +
      "#bemaxx-footer-srcdoc-modal.is-open{display:block;}" +
      "#bemaxx-footer-srcdoc-modal .bemaxx-modal-backdrop{position:absolute;inset:0;background:rgba(15,23,42,.72);backdrop-filter:blur(4px);}" +
      "#bemaxx-footer-srcdoc-modal .bemaxx-modal-dialog{position:relative;width:min(1100px,calc(100vw - 32px));height:min(86vh,900px);margin:7vh auto;background:#fff;border-radius:20px;overflow:hidden;box-shadow:0 25px 80px rgba(0,0,0,.35);display:flex;flex-direction:column;}" +
      "#bemaxx-footer-srcdoc-modal .bemaxx-modal-header{display:flex;align-items:center;justify-content:space-between;gap:16px;padding:16px 20px;border-bottom:1px solid #e5e7eb;background:#fff;flex:0 0 auto;}" +
      "#bemaxx-footer-srcdoc-modal .bemaxx-modal-title{font-size:18px;font-weight:700;color:#111827;line-height:1.2;}" +
      "#bemaxx-footer-srcdoc-modal .bemaxx-modal-actions{display:flex;align-items:center;gap:10px;}" +
      "#bemaxx-footer-srcdoc-modal .bemaxx-modal-open-new{font-size:14px;font-weight:600;color:#dc2626;text-decoration:none;white-space:nowrap;}" +
      "#bemaxx-footer-srcdoc-modal .bemaxx-modal-open-new:hover{text-decoration:underline;}" +
      "#bemaxx-footer-srcdoc-modal .bemaxx-modal-close{appearance:none;border:0;background:#111827;color:#fff;width:38px;height:38px;border-radius:999px;font-size:24px;line-height:1;cursor:pointer;display:inline-flex;align-items:center;justify-content:center;flex:0 0 auto;}" +
      "#bemaxx-footer-srcdoc-modal .bemaxx-modal-close:hover{opacity:.9;}" +
      "#bemaxx-footer-srcdoc-modal .bemaxx-modal-body{position:relative;flex:1 1 auto;min-height:0;background:#f8fafc; margin: 0 10px; overflow-wrap: break-word;}" +
      "#bemaxx-footer-srcdoc-modal .bemaxx-modal-loader{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;font-size:15px;font-weight:600;color:#475569;background:#f8fafc;z-index:1;}" +
      "#bemaxx-footer-srcdoc-modal iframe{width:100%;height:100%;border:0;background:#fff;position:relative;z-index:2;}" +
      "@media (max-width: 768px){" +
      "  #bemaxx-footer-srcdoc-modal .bemaxx-modal-dialog{width:calc(100vw - 16px);height:92vh;margin:4vh auto;border-radius:16px;}" +
      "  #bemaxx-footer-srcdoc-modal .bemaxx-modal-header{padding:14px 14px;}" +
      "  #bemaxx-footer-srcdoc-modal .bemaxx-modal-title{font-size:16px;}" +
      "  #bemaxx-footer-srcdoc-modal .bemaxx-modal-open-new{display:none;}" +
      "}";
    document.head.appendChild(style);
  }

  function ensureModal() {
    ensureStyles();
    var existing = document.getElementById("bemaxx-footer-srcdoc-modal");
    if (existing) return existing;

    var modal = document.createElement("div");
    modal.id = "bemaxx-footer-srcdoc-modal";
    modal.setAttribute("aria-hidden", "true");
    modal.innerHTML =
      "" +
      '<div class="bemaxx-modal-backdrop"></div>' +
      '<div class="bemaxx-modal-dialog" role="dialog" aria-modal="true" aria-labelledby="bemaxx-footer-srcdoc-title">' +
      '<div class="bemaxx-modal-header">' +
      '<div class="bemaxx-modal-title" id="bemaxx-footer-srcdoc-title">Info</div>' +
      '<div class="bemaxx-modal-actions">' +
      '<a class="bemaxx-modal-open-new" href="#" target="_blank" rel="noopener noreferrer"></a>' +
      // In neuem Tab öffnen
      '<button type="button" class="bemaxx-modal-close" aria-label="Schließen">×</button>' +
      "</div>" +
      "</div>" +
      '<div class="bemaxx-modal-body">' +
      '<div class="bemaxx-modal-loader">Inhalt wird geladen...</div>' +
      '<iframe title="Footer-Seite"></iframe>' +
      "</div>" +
      "</div>";

    document.body.appendChild(modal);

    var closeBtn = modal.querySelector(".bemaxx-modal-close");
    var backdrop = modal.querySelector(".bemaxx-modal-backdrop");
    var iframe = modal.querySelector("iframe");
    var loader = modal.querySelector(".bemaxx-modal-loader");

    function closeModal() {
      modal.classList.remove("is-open");
      modal.setAttribute("aria-hidden", "true");
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
      setTimeout(function () {
        if (!modal.classList.contains("is-open")) {
          iframe.removeAttribute("srcdoc");
          loader.style.display = "flex";
        }
      }, 150);
    }

    closeBtn.addEventListener("click", closeModal);
    backdrop.addEventListener("click", closeModal);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && modal.classList.contains("is-open")) {
        closeModal();
      }
    });

    iframe.addEventListener("load", function () {
      loader.style.display = "none";
    });

    modal._open = async function (url, title) {
      modal.querySelector(".bemaxx-modal-title").textContent = title || "Info";
      modal.querySelector(".bemaxx-modal-open-new").href = url;
      loader.style.display = "flex";
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";

      try {
        var res = await fetch(url, { credentials: "same-origin" });
        if (!res.ok) throw new Error("HTTP " + res.status);
        var html = await res.text();
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");

        var bodyClass = doc.body ? doc.body.getAttribute("class") || "" : "";
        var titleText = doc.title || title || "Info";

        // Keep stylesheet links and inline styles from fetched page head
        var headParts = [];
        var nodes = doc.querySelectorAll(
          'head link[rel="stylesheet"], head style, head base',
        );
        nodes.forEach(function (node) {
          headParts.push(node.outerHTML);
        });

        // Ensure relative assets resolve correctly
        headParts.unshift('<base href="' + location.origin + '">');

        // Add a few safety styles so the embedded page fits nicely
        headParts.push(
          '<style>html,body{margin:0;padding:0;background:#fff;} body{overflow:auto !important;} .shopify-section-group-header-group,.shopify-section-group-footer-group,header,footer,announcement-bar,[id*="shopify-section-header"],[id*="shopify-section-footer"]{display:none !important;} main#MainContent, #MainContent, main, .shopify-policy__container, .page-width{max-width:none !important;} body{padding:24px !important; box-sizing:border-box;} @media (max-width:768px){body{padding:16px 25px !important;}}</style>',
        );

        // Prefer main content, otherwise fall back to body
        var content =
          doc.querySelector("main#MainContent") ||
          doc.querySelector("#MainContent") ||
          doc.querySelector("main") ||
          doc.querySelector(".shopify-policy__container") ||
          doc.body;
        var bodyHtml = content
          ? content.innerHTML
          : "<p>Inhalt konnte nicht geladen werden.</p>";

        var srcdoc =
          '<!doctype html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1">' +
          "<title>" +
          escapeHtml(titleText) +
          "</title>" +
          headParts.join("") +
          '</head><body class="' +
          escapeAttr(bodyClass) +
          '">' +
          bodyHtml +
          "</body></html>";

        iframe.srcdoc = srcdoc;
      } catch (err) {
        iframe.srcdoc =
          '<!doctype html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1"><style>body{font-family:Arial,sans-serif;padding:24px;color:#111827} .err{padding:16px;border:1px solid #e5e7eb;border-radius:12px;background:#fff}</style></head><body><div class="err"><strong>Inhalt konnte nicht geladen werden.</strong><br><br>Bitte öffnen Sie die Seite in einem neuen Tab.</div></body></html>';
      }
    };

    return modal;
  }

  function escapeHtml(str) {
    return String(str || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function escapeAttr(str) {
    return String(str || "").replace(/"/g, "&quot;");
  }

  function bindFooterModal() {
    var modal = ensureModal();

    document.addEventListener(
      "click",
      function (e) {
        var link = e.target.closest("a");
        if (!footerLinkMatches(link)) return;
        var href = link.getAttribute("href");
        if (!href || href === "#" || /^javascript:/i.test(href)) return;

        e.preventDefault();
        e.stopPropagation();
        modal._open(href, (link.textContent || "").trim());
      },
      true,
    );
  }

  ready(bindFooterModal);
})();


// (function () {
//   function setBemaxxFavicon() {
//     var faviconUrl =
//       "https://cdn.shopify.com/s/files/1/0813/4656/0293/files/faviconV2.png?v=1699563702";

//     // Remove existing favicons that may override yours
//     document
//       .querySelectorAll('link[rel="icon"], link[rel="shortcut icon"], link[rel="apple-touch-icon"]')
//       .forEach(function (el) {
//         el.parentNode.removeChild(el);
//       });

//     // Standard favicon
//     var icon = document.createElement("link");
//     icon.rel = "icon";
//     icon.type = "image/png";
//     icon.sizes = "32x32";
//     icon.href = faviconUrl;
//     document.head.appendChild(icon);

//     // Older browser fallback
//     var shortcut = document.createElement("link");
//     shortcut.rel = "shortcut icon";
//     shortcut.type = "image/png";
//     shortcut.href = faviconUrl;
//     document.head.appendChild(shortcut);

//     // Mobile / Apple fallback
//     var apple = document.createElement("link");
//     apple.rel = "apple-touch-icon";
//     apple.href = faviconUrl;
//     document.head.appendChild(apple);
//   }

//   if (document.readyState === "loading") {
//     document.addEventListener("DOMContentLoaded", setBemaxxFavicon);
//   } else {
//     setBemaxxFavicon();
//   }
// })();